import { AdminTwitterPerformanceResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type AdminTwitterPerformanceResponseInput = z.input<typeof AdminTwitterPerformanceResponseSchema>;
export type AdminTwitterPerformanceResponseOutput = z.output<typeof AdminTwitterPerformanceResponseSchema>;

export function serializeAdminTwitterPerformanceResponse(
  payload: AdminTwitterPerformanceResponseInput
): AdminTwitterPerformanceResponseOutput {
  return AdminTwitterPerformanceResponseSchema.parse(payload);
}
